import { configureStore } from "@reduxjs/toolkit";
import toggleSlice from "../features/toggle/toggleSlice";
import userSlice from "../redux/userSlice";
import loginSlice from "../redux/loginSlice";
import languagesSlice from "../redux/langSlice";
import settingSlice from "../redux/settingSlice";
import notificationSlice from "../redux/notificationSlice";
import menuSlice from "../redux/menuSlice";

export const store = configureStore({
	reducer: {
		toggle: toggleSlice,
		user: userSlice,
		dataLogin: loginSlice,
		languages: languagesSlice,
		settings: settingSlice,
		notifications: notificationSlice,
		menuData: menuSlice
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
});
